import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GoogleTagManagerService } from '@/services/google-tag-manager/google-tag-manager-service';
import { GoogleTagManagerServiceImpl } from '@/services/google-tag-manager/impls/google-tag-manager-service-impl';

/**
 * Google Tag Manager 服务模块
 */
export const googleTagManagerModule = new ContainerModule((bind) => {
    bind<GoogleTagManagerService>(GoogleTagManagerService).to(GoogleTagManagerServiceImpl);
});
